import EFVideo from '@/components/UI/EFVideo';
import Image from '@/components/UI/Image';
import { getImageLocal } from '@/utils/locals';
import { useGlobal } from '@/utils/useGlobal';
import { TweenMax } from 'gsap';
import css from './index.module.scss';
export default function home3({ data }: any) {
    const { useEffect, useRouter, useState, useRef } = useGlobal();
    const { locale } = useRouter();
    const imgLocal = getImageLocal(locale, ['cn', 'za']);
    const { text1, text2, text3, isVideo = true, img = '/img/mm100/preview/2-simple.jpg', cls = '.home3' } = data;
    const video = [`/video/mm100m/controls_${imgLocal}.webm`, `/video/mm100/controls_${imgLocal}.mp4`];

    const fadeIn = (el: any) => {
        const target = document.querySelector(`.kitProduct ${cls} .mm100_home3 ${el}`) as HTMLElement;
        const targetH = target?.offsetHeight || 100;

        const tween1 = TweenMax.fromTo(target, 0.5, { opacity: 0 }, { opacity: 0 });
        const scene1 = new ScrollMagic.Scene({
            triggerElement: target,
            offset: 0,
            triggerHook: 1,
            duration: targetH,
        });
        scene1.setTween(tween1);
        scene1.addTo(AniContainer);

        const scene2 = new ScrollMagic.Scene({
            triggerElement: target,
            offset: targetH,
            triggerHook: 1,
            duration: targetH,
        });
        const tween2 = TweenMax.fromTo(target, 0.5, { opacity: 0 }, { opacity: 1 });
        scene2.setTween(tween2);
        scene2.addTo(AniContainer);
    };

    useEffect(() => {
        // 文字透明渐变 - 进入
        fadeIn('.text1');
        fadeIn('.text2');
        fadeIn('.text3');
    }, []);

    const [enter, setEnter] = useState(false);
    const videoRef = useRef();
    useEffect(() => {
        // mm100_home2进入视窗渲染video
        if (isVideo) {
            const videoEl = document.querySelector(`.kitProduct ${cls} .mm100_home3`) as HTMLElement;
            const scene = new ScrollMagic.Scene({
                triggerElement: videoEl,
                triggerHook: 1,
                offset: 0,
            });
            scene.on('enter', () => {
                setEnter(true);
            });
            scene.addTo(AniContainer);
        }
    }, []);

    useEffect(() => {
        if (videoRef && isVideo) {
            const videoBoxEl = document.querySelector(`.kitProduct ${cls} .mm100_home3 .videoBox`) as HTMLElement;
            // 视频的一半区域进入视窗后开始播放
            const scene1 = new ScrollMagic.Scene({
                triggerElement: `.kitProduct ${cls} .mm100_home3 .videoBox`,
                triggerHook: 1,
                offset: videoBoxEl?.offsetHeight / 2,
            });
            scene1.on('enter', () => {
                videoRef?.current?.play();
            });
            AniContainer.addScene(scene1);
        }
    }, [videoRef]);

    return (
        <div className={`mm100_home3 ${css.mm100_home3}`}>
            <div className="container">
                <div className="textBox">
                    <p className="text1">{text1}</p>
                    <p className="text2">{text2}</p>
                    <p className="text3">{text3}</p>
                </div>
                {isVideo && (
                    <div className="videoBox">
                        {enter && <EFVideo ref={videoRef} className="mm100_home3_video" sources={video} width={'100%'} height={'100%'} autoPlay={false} />}
                    </div>
                )}
                {!isVideo && (
                    <div className="imgBox">
                        <Image src={img} layout="fill" className="fullImgs" alt={text2} aria-label={text2} />
                    </div>
                )}
            </div>
        </div>
    );
}
